package com.dotdrives.web.pages.onboarding

import com.dotdrives.controller.OnboardingController
import com.dotdrives.controller.OnboardingUiState
import com.dotdrives.design.DotButtonVariant
import com.dotdrives.web.ui.DotAvatar
import com.dotdrives.web.ui.DotBanner
import com.dotdrives.web.ui.DotButton
import react.FC
import react.Props
import react.dom.html.ReactHTML.button
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.h1
import react.dom.html.ReactHTML.input
import react.dom.html.ReactHTML.option
import react.dom.html.ReactHTML.p
import react.dom.html.ReactHTML.select
import react.dom.html.ReactHTML.span
import react.useEffect
import web.cssom.ClassName
import web.html.ButtonType
import web.html.InputType
import web.html.button as buttonType
import web.html.email

external interface InviteStepProps : Props {
    var controller: OnboardingController
    var state: OnboardingUiState
    var canWrite: Boolean
    var onBack: () -> Unit
    var onSkip: () -> Unit
    var onContinue: () -> Unit
}

val InviteStep = FC<InviteStepProps> { props ->
    val state = props.state

    useEffect(Unit) {
        if (props.controller.state.value.invites.isEmpty()) {
            props.controller.addInvite("", "member")
        }
    }

    div {
        className = ClassName("onboarding-step-form")

        div {
            className = ClassName("onboarding-step-meta dot-meta")
            +"STEP 3 OF 4"
        }
        h1 {
            className = ClassName("onboarding-step-title dot-heading")
            +"Invite your team"
        }
        p {
            className = ClassName("onboarding-step-copy")
            +"Fundraising is a team sport. Add teammates now or skip and do it later."
        }

        state.error?.let { message ->
            DotBanner {
                this.message = message
            }
        }

        div {
            className = ClassName("onboarding-invite-list")
            state.invites.forEachIndexed { index, invite ->
                div {
                    className = ClassName("onboarding-invite-row")
                    DotAvatar {
                        initials = inviteInitials(invite.email)
                        size = 34
                        className = "onboarding-invite-avatar"
                    }
                    input {
                        className = ClassName("onboarding-invite-email")
                        type = InputType.email
                        value = invite.email
                        placeholder = "teammate@example.org"
                        ariaLabel = "Teammate ${index + 1} email"
                        onChange = { event ->
                            props.controller.updateInvite(index, event.currentTarget.value, invite.role)
                        }
                    }
                    select {
                        className = ClassName("onboarding-role-select")
                        value = invite.role
                        ariaLabel = "Teammate ${index + 1} role"
                        onChange = { event ->
                            props.controller.updateInvite(index, invite.email, event.currentTarget.value)
                        }
                        option {
                            value = "admin"
                            +"Admin"
                        }
                        option {
                            value = "member"
                            +"Member"
                        }
                        option {
                            value = "field"
                            +"Field"
                        }
                    }
                    button {
                        type = ButtonType.buttonType
                        className = ClassName("onboarding-remove-invite")
                        title = "Remove teammate"
                        ariaLabel = "Remove teammate ${index + 1}"
                        onClick = { props.controller.removeInvite(index) }
                        +"×"
                    }
                }
            }
            button {
                type = ButtonType.buttonType
                className = ClassName("onboarding-add-invite")
                onClick = { props.controller.addInvite("", "member") }
                +"+ Add another teammate"
            }
        }

        div {
            className = ClassName("onboarding-tip-card")
            span {
                ariaHidden = true
                +"💡"
            }
            span {
                +"Field representatives get a simplified view — they submit updates from the field without seeing donor financials."
            }
        }

        div {
            className = ClassName("onboarding-actions onboarding-actions-three")
            DotButton {
                text = "← Back"
                onClick = props.onBack
                variant = DotButtonVariant.Secondary
            }
            DotButton {
                text = "Skip"
                onClick = props.onSkip
                variant = DotButtonVariant.Secondary
            }
            if (props.canWrite) {
                DotButton {
                    text = inviteActionLabel(state.invites)
                    onClick = props.onContinue
                    loading = state.loading
                    enabled = canSubmitInvites(state)
                    className = "onboarding-action-primary"
                }
            }
        }
    }
}
